import React from "react";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import _ from "lodash";
import AdminPersonalDocumentForm from "../../profile/document/AdminPersonalDocumentForm";

const UploadDocumentsStep = ({ requestedDocuments, onBack, stageId, showBackButton = true }) => {
  return (
    <>
      <Row>
        <Col md="12">
          <h3 className="fs-6 text-muted mb-0 fw-bold">Subir Documentos</h3>
          <p className="small text-dark">
            Por favor sube los documentos requeridos.
          </p>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <Card className="material-shadow">
            <CardBody>
              {_.map(requestedDocuments, document => (
                <AdminPersonalDocumentForm
                  key={document.id}
                  descriptor={document.document_descriptor}
                  personalDocument={document.document ? document : {}}
                  stageId={stageId}
                />
              ))}
            </CardBody>
          </Card>
        </Col>
      </Row>
      {showBackButton && (
        <Row className="mt-3">
          <Col md="12" className="text-right">
            <Button color="secondary" onClick={onBack}>Atrás</Button>
          </Col>
        </Row>
      )}
    </>
  );
};

export default UploadDocumentsStep;
